import { TRouterLink } from "@/models/router";
import { RouteConfig } from "vue-router";

import { REmployerEmployeesTemplateDocuments } from "../Template/views/Documents/REmployerEmployeesTemplateDocuments";
import { REmployerEmployeesTemplateEmployment } from "../Template/views/Employment/REmployerEmployeesTemplateEmployment";
import { REmployerEmployeesTemplatePersonalInfo } from "../Template/views/PersonalInfo/REmployerEmployeesTemplatePersonalInfo";
import { REmployerEmployeesTemplateSummary } from "../Template/views/Summary/REmployerEmployeesTemplateSummary";
import { REmployerEmployeeCompanyDataHistory } from "../Template/views/DataHistory/REmployerEmployeeCompanyDataHistory";

export const REmployeesTemplate: RouteConfig = {
  path: ":id(\\d+)",
  component: () =>
    import(
      /* webpackChunkName: "employees-template" */
      "./VEmployeesTemplate.vue"
    ),
  meta: {
    title: "Employee",
  },
  children: [
    {
      path: "",
      redirect: REmployerEmployeesTemplateSummary.path,
    },
    REmployerEmployeesTemplateSummary,
    REmployerEmployeesTemplatePersonalInfo,
    REmployerEmployeesTemplateEmployment,
    REmployerEmployeesTemplateDocuments,
    REmployerEmployeeCompanyDataHistory,
  ],
};

export const employerEmployeeTemplateLinks = (REmployeesTemplate.children ?? []).reduce(
  (items, { path, meta }) =>
    meta && meta.label
      ? items.concat({
          path: path ? "/" + path : "",
          label: meta.label,
          basePath: meta.basePath,
        })
      : items,
  [] as TRouterLink[]
);
